export const ordenarHabitacionesTorrePiso = ({arrHabitaciones}) => {

    let arrPisos = arrHabitaciones.map((it) => it.piso)
    let setPisos = new Set(arrPisos)
    let pisos = [...setPisos]
    pisos.sort()

    let arrTorres = arrHabitaciones.map((it) => it.torre)
    let setTorres = new Set(arrTorres)
    let torres = [...setTorres]
    torres.sort()


    let arr = []
    for (let k = 0; k < torres.length; k++) {

        let arrPisos = []
        let torre = torres[k]

        for (let i = 0; i < pisos.length; i++) {
            let piso = pisos[i]
            let arrHab = []
            for (let j = 0; j < arrHabitaciones.length; j++) {
                if (arrHabitaciones[j].piso === pisos[i] && arrHabitaciones[j].torre === torre) {
                    arrHab.push(arrHabitaciones[j])
                }
            }

            let obj = {
                torre: torre,
                piso: piso,
                habitaciones: arrHab

            }

            arrPisos.push(obj)
        }


        let objTorre = {
            torre: torre,
            habsPisos: arrPisos
        }

        arr.push(objTorre)


    }

    console.log(arr)

    return arr
}
